var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSingleUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "30px",
    viewBox: "0 0 26 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9F255F30-3AD0-4F53-A0AA-A9FEAF19DE50") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1-SignIn/SignUp",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.3.0-Mojo-SignUp",
    transform: "translate(-851.000000, -316.000000)",
    stroke: "#0964DE",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "card-active",
    transform: "translate(760.000000, 298.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "signUp-single-icon",
    transform: "translate(91.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-12",
    x: 7.5,
    y: 1.5,
    width: 11,
    height: 11,
    rx: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9993744,16 C10.2375252,16 7.878959,16.6803509 5.93394957,18.0706993 C3.9673924,19.4764507 2.43149426,21.5959841 1.29583261,24.40367 C1.13473937,24.8019393 1.0519267,25.2275273 1.0519267,25.6571429 C1.0519267,26.5802469 1.42608854,27.4159607 2.03102634,28.0208988 C2.63596435,28.625837 3.47167849,28.9999993 4.39478284,29 L21.6039655,29 C22.033581,29 22.459169,28.9171873 22.8574383,28.7560941 C23.7131896,28.4099572 24.3476273,27.7497272 24.6815932,26.9620936 C25.0155591,26.1744598 25.0490529,25.2594222 24.7029164,24.4036704 C23.567255,21.5959847 22.0313568,19.4764511 20.0647996,18.0706996 C18.1197901,16.680351 15.7612238,16 12.9993744,16 Z",
    id: "Rectangle-12-Copy"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleUserIcon);
export default __webpack_public_path__ + "static/media/single-user-icon.57b8d44ff2075863a250a15f274a2578.svg";
export { ForwardRef as ReactComponent };